"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormControl = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _logging = require("../../util/logging");
var _FormField = require("../FormField/FormField.context");
var _FormControl = require("./FormControl.styles");
var _excluded = ["controlId", "error", "readOnly", "required"];
/**
 * @related ['Checkbox', 'Input', 'Radio', 'Select', 'Textarea']
 * @since 8.0.0
 */
var FormControl = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var controlId = _ref.controlId,
    error = _ref.error,
    readOnly = _ref.readOnly,
    required = _ref.required,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var context = (0, _react.useContext)(_FormField.FormFieldContext);
  if (typeof controlId !== 'undefined') {
    (0, _logging.logDeprecation)("`controlId` should not be used on form controls, instead use the native `id` attribute");
  }
  return /*#__PURE__*/_react.default.createElement(_FormControl.StyledFormControl, (0, _extends2.default)({
    ref: forwardedRef,
    id: typeof controlId !== 'undefined' ? controlId : context.controlId,
    "aria-invalid": typeof error !== 'undefined' ? error : context.error,
    "aria-describedby": context.descriptionId,
    disabled: context.disabled,
    required: typeof required !== 'undefined' ? required : context.required,
    "aria-required": typeof required !== 'undefined' ? required : context.required,
    readOnly: typeof readOnly !== 'undefined' ? readOnly : context.readOnly
  }, rest));
});
exports.FormControl = FormControl;
FormControl.displayName = 'FormControl';
FormControl.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Indicate that the value entered is invalid using the native
   * [`aria-invalid`](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-invalid_attribute)
   * attribute.
   * This will be set automatically by the `error` prop.
   */
  'aria-invalid': _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  /**
   * If there are multiple labels for a control, it is best to set the native
   * [`aria-describedby`](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-describedby_attribute)
   * with each of the label ids. You can read more [here](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-describedby_attribute).
   * Can be controlled by `FormField` context.
   */
  'aria-describedby': _propTypes.default.string,
  /**
   * @deprecated Use the native `id` attributed instead.
   */
  'controlId': _propTypes.default.string,
  /**
   * Signals that there is an error with the value and sets the
   * [aria-invalid](https://www.w3.org/TR/wai-aria/#aria-invalid) property.
   */
  'error': _propTypes.default.bool,
  /**
   * The native [`id`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id)
   * attribute.
   * Can be controlled by `FormField` context.
   */
  'id': _propTypes.default.string,
  /**
   * Mark the control as required with the native [`required`](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/required)
   * attribute.
   * Can be controlled by `FormField` context.
   */
  'required': _propTypes.default.bool,
  /**
   * Mark the control as disabled with the native [`disabled`](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/disabled)
   * attribute.
   * Can be controlled by `FormField` context.
   */
  'disabled': _propTypes.default.bool,
  /**
   * Mark the input as read-only with the native [`readonly`](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/readonly)
   * attribute.
   * Can be controlled by `FormField` context.
   *
   * @since 8.27.0
   */
  'readOnly': _propTypes.default.bool
} : {};